import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import styles from "../../appointmentsPage.module.css";
import { INoShowStats } from "../../types/noShowPredictor.types";

interface INoShowStatsProps {
  stats: INoShowStats;
}

/**
 * Statistics cards for No-Show Predictor
 */
const NoShowStats: React.FC<INoShowStatsProps> = ({ stats }) => {
  const formatTrend = (value: number, isImprovement: boolean = false): string => {
    const sign = value > 0 ? '↑' : value < 0 ? '↓' : '';
    const absValue = Math.abs(value);
    return `${sign} ${absValue}${isImprovement ? '' : ''}`;
  };

  return (
    <div className={styles.noShowStatsGrid}>
      {/* High Risk Appointments */}
      <div className={`${styles.noShowStatCard} ${styles.danger}`}>
        <div className={styles.noShowStatHeader}>
          <span className={styles.noShowStatLabel}>{t("NOSHOW_STAT_HIGH_RISK")}</span>
          <span className={`${styles.noShowStatIcon} ${styles.danger}`}>⚠️</span>
        </div>
        <div className={styles.noShowStatValue}>{stats.highRiskCount}</div>
        <div className={`${styles.noShowStatTrend} ${stats.highRiskTrend > 0 ? styles.trendUp : styles.trendDown}`}>
          {formatTrend(stats.highRiskTrend)} {t("NOSHOW_TREND_FROM_YESTERDAY")}
        </div>
      </div>

      {/* Prediction Accuracy */}
      <div className={`${styles.noShowStatCard} ${styles.primary}`}>
        <div className={styles.noShowStatHeader}>
          <span className={styles.noShowStatLabel}>{t("NOSHOW_STAT_ACCURACY")}</span>
          <span className={`${styles.noShowStatIcon} ${styles.primary}`}>🎯</span>
        </div>
        <div className={styles.noShowStatValue}>{stats.predictionAccuracy}%</div>
        <div className={`${styles.noShowStatTrend} ${stats.accuracyTrend > 0 ? styles.trendUp : styles.trendNeutral}`}>
          {formatTrend(stats.accuracyTrend)}% {t("NOSHOW_TREND_FROM_LAST_MONTH")}
        </div>
      </div>

      {/* Average Cancellation Rate */}
      <div className={`${styles.noShowStatCard} ${styles.warning}`}>
        <div className={styles.noShowStatHeader}>
          <span className={styles.noShowStatLabel}>{t("NOSHOW_STAT_CANCELLATION_RATE")}</span>
          <span className={`${styles.noShowStatIcon} ${styles.warning}`}>📊</span>
        </div>
        <div className={styles.noShowStatValue}>{stats.averageCancellationRate}%</div>
        <div className={`${styles.noShowStatTrend} ${stats.cancellationTrend < 0 ? styles.trendDown : styles.trendUp}`}>
          {formatTrend(stats.cancellationTrend)}% {stats.cancellationTrend < 0 ? t("NOSHOW_TREND_IMPROVEMENT") : ''}
        </div>
      </div>

      {/* Prevented This Week */}
      <div className={`${styles.noShowStatCard} ${styles.success}`}>
        <div className={styles.noShowStatHeader}>
          <span className={styles.noShowStatLabel}>{t("NOSHOW_STAT_PREVENTED")}</span>
          <span className={`${styles.noShowStatIcon} ${styles.success}`}>✓</span>
        </div>
        <div className={styles.noShowStatValue}>{stats.preventedThisWeek}</div>
        <div className={`${styles.noShowStatTrend} ${styles.trendNeutral}`}>
          {t("NOSHOW_TREND_THANKS_REMINDERS")}
        </div>
      </div>
    </div>
  );
};

export default NoShowStats;
